<div role="alert">
  <mat-dialog-content [attr.aria-label]="ariaLabelText">
   <span style="color: black;">{{ message }} </span>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button class="primary-button modal-button" mat-dialog-close tabindex="0">
      {{ okButtonLabel }}
    </button>
  </mat-dialog-actions>
</div>
